import { Link } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useDiseaseAreas } from "@/api/hooks/diseaseAreas";

function formatDate(iso: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString();
}

export default function DiseaseAreasList() {
  const { data, isLoading, error } = useDiseaseAreas();

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error.message}</Alert>;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h5">Disease areas</Typography>
        <Link to="new" style={{ textDecoration: "none" }}>
          <Button variant="contained" startIcon={<Add />}>
            New
          </Button>
        </Link>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Code</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Master protocol</TableCell>
              <TableCell>IRB approved</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {(data ?? []).map((da) => (
              <TableRow key={da.id} hover>
                <TableCell sx={{ fontFamily: "ui-monospace, Menlo, monospace" }}>
                  {da.code}
                </TableCell>
                <TableCell>{da.name}</TableCell>
                <TableCell>{da.master_protocol_number ?? "—"}</TableCell>
                <TableCell>{formatDate(da.master_irb_approved_at)}</TableCell>
                <TableCell align="right">
                  <Link to={`${da.id}/edit`}>Edit</Link>
                </TableCell>
              </TableRow>
            ))}
            {(data ?? []).length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4, color: "text.secondary" }}>
                  No disease areas yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
